import { HbtFileExtensionType } from '@hobt/constants';
import { AttachmentsViewPropsFields } from 'Components/Common/AttachmentsView/types';

export interface AttachmentsViewComponentProps {
  fields: AttachmentsViewPropsFields;
}

export interface AddCommentFormPropsFields {
  content: FieldValue;
  formTitle: FieldValue;
  submitBtn: FieldValue;
  cancelBtn: FieldValue;
  cautionText: FieldValue;
  description: FieldValue;
  limitNumber: FieldValue;
  characterLimit: FieldValue;
  attachmentsView: AttachmentsViewComponentProps;
}

export interface AddCommentFormProps {
  name?: string;
  fields: AddCommentFormPropsFields;
  onCancelCallback?: () => void;
  onSuccessCallback?: () => void;
  onErrorCallback?: () => void;
}

export const AllowedFileTypes = [
  HbtFileExtensionType.CSV,
  HbtFileExtensionType.XLSX,
  HbtFileExtensionType.XLSM,
  HbtFileExtensionType.XLSB,
  HbtFileExtensionType.XLTX,
  HbtFileExtensionType.XLTM,
  HbtFileExtensionType.XLS,
  HbtFileExtensionType.XLT,
  HbtFileExtensionType.XML,
  HbtFileExtensionType.XLAM,
  HbtFileExtensionType.XLA,
  HbtFileExtensionType.XLW,
  HbtFileExtensionType.XLR,
  HbtFileExtensionType.PDF,
  HbtFileExtensionType.JPG,
  HbtFileExtensionType.DOC,
  HbtFileExtensionType.DOCX
];
